<div>
    <div class="d-flex flex-wrap gap-3 mb-3 align-items-end">
        <div>
            <label class="form-label mb-1" for="offers-filter-published">{{ 'offer_filter_online' | translate }}</label>
            <select
                id="offers-filter-published"
                class="form-select form-select-sm"
                [(ngModel)]="publishedFilter"
                (ngModelChange)="onFiltersChanged()"
            >
                <option value="all">{{ 'offer_filter_all' | translate }}</option>
                <option value="1">{{ 'offer_visibility_online' | translate }}</option>
                <option value="0">{{ 'offer_visibility_offline' | translate }}</option>
            </select>
        </div>
        <div>
            <label class="form-label mb-1" for="offers-filter-archived">{{ 'offer_filter_archived' | translate }}</label>
            <select
                id="offers-filter-archived"
                class="form-select form-select-sm"
                [(ngModel)]="archivedFilter"
                (ngModelChange)="onFiltersChanged()"
            >
                <option value="all">{{ 'offer_filter_all' | translate }}</option>
                <option value="0">{{ 'offer_filter_no' | translate }}</option>
                <option value="1">{{ 'offer_filter_yes' | translate }}</option>
            </select>
        </div>
    </div>

    <ng-container *ngIf="!loadingOffers && offers.items.length > 0">
        <div class="table-responsive">
            <table class="table mw-850 profile-table-cards offers-table">
                <thead>
                    <tr>
                        <th></th>
                        <th>{{ 'Offer title'|translate }}</th>
                        <th>{{ 'Price'|translate }}</th>
                        <th>{{ 'Stocks'|translate }}</th>
                        <th>{{ 'offer_list_status_column'|translate }}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let offer of offers.items">
                        <td class="profile-table-card-media">
                            <app-picture [picture]="offer.medias[0]" size="50x50" *ngIf="offer.medias.length > 0"></app-picture>
                        </td>
                        <td class="profile-table-card-title">{{ offer.name }}</td>
                        <td [attr.data-label]="'Price' | translate">
                            <span class="offer-table-value"><app-price [price]="offer.priceObject"></app-price></span>
                        </td>
                        <td [attr.data-label]="'Stocks' | translate">
                            <span class="offer-table-value">
                                {{ offer.totalStocks }} <span class="fw-bold">({{ offer.totalStocksPending * -1 }})</span>
                            </span>
                        </td>
                        <td [attr.data-label]="'offer_list_status_column' | translate">
                            <span class="badge" [ngClass]="offerStatusBadgeClass(offer)">{{ offerStatusLabel(offer) | translate }}</span>
                        </td>
                        <td class="text-end profile-table-card-actions">
                            <div class="text-nowrap d-inline-flex justify-content-end gap-2 flex-wrap">
                                <button
                                    *ngIf="canShowDeactivate(offer)"
                                    type="button"
                                    class="btn btn-sm btn-outline-secondary"
                                    (click)="setPublished(offer, false)"
                                >
                                    {{ 'offer_action_deactivate' | translate }}
                                </button>
                                <button
                                    *ngIf="canShowActivate(offer)"
                                    type="button"
                                    class="btn btn-sm btn-outline-primary"
                                    (click)="setPublished(offer, true)"
                                >
                                    {{ 'offer_action_activate' | translate }}
                                </button>
                                <button *ngIf="canArchive(offer)" type="button" class="btn btn-sm btn-outline-dark" (click)="archiveOffer(offer)">
                                    {{ 'offer_action_archive' | translate }}
                                </button>
                                <button *ngIf="canUnarchive(offer)" type="button" class="btn btn-sm btn-outline-secondary" (click)="unarchiveOffer(offer)">
                                    {{ 'offer_action_unarchive' | translate }}
                                </button>
                                <button *ngIf="canReactivate(offer)" type="button" class="btn btn-sm btn-primary" (click)="reactivateOffer(offer)">
                                    {{ 'offer_action_go_online' | translate }}
                                </button>
                                <button type="button" class="btn btn-link-primary" (click)="updateOffer(offer)">
                                    <i class="bi bi-pencil"></i>
                                </button>
                                <button type="button" class="btn btn-link-danger" (click)="removeOffer(offer)">
                                    <i class="bi bi-trash"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <app-pagination
                *ngIf="offers.total > offers.perPage"
                [total]="offers.total"
                [perPage]="offers.perPage"
                [page]="offers.page"
                (pageChanged)="pageChanged($event)"
            ></app-pagination>
        </div>
    </ng-container>

    <ng-container *ngIf="!loadingOffers && offers.items.length === 0">
        <div class="py-4">
            <em *ngIf="isDefaultFilters">{{ 'You don\'t have any offers yet'|translate }}</em>
            <em *ngIf="!isDefaultFilters">{{ 'offer_filter_no_results' | translate }}</em>
        </div>
    </ng-container>

    <ng-container *ngIf="loadingOffers">
        <div class="py-4 text-center">
            <app-loader></app-loader>
        </div>
    </ng-container>
</div>
